var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"banner-container"},[(_vm.url)?_c('img',{staticClass:"banner-image",attrs:{"src":_vm.url}}):_c('img',{staticClass:"banner-image",attrs:{"src":"https://aimg8.oss-cn-shanghai.aliyuncs.com/website/wap_bargain/banner.png"}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-593d6322","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/pages/Bargain/components/Banner.vue
// module id = null
// module chunks = 